/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Spanish (International)
export default {
  'fabric.emoji.add.custom.emoji.label': 'Añade tu propio emoji',
  'fabric.emoji.add.label': 'Añadir emoji',
  'fabric.emoji.cancel.label': 'Cancelar',
  'fabric.emoji.categories.label': 'Elige una categoría de emojis',
  'fabric.emoji.categories.search.results': 'Resultados de búsqueda',
  'fabric.emoji.category.activity': 'Actividades',
  'fabric.emoji.category.all.uploads': 'Todos los elementos subidos',
  'fabric.emoji.category.flags': 'Banderas',
  'fabric.emoji.category.foods': 'Comida y bebida',
  'fabric.emoji.category.frequent': 'Frecuentes',
  'fabric.emoji.category.nature': 'Naturaleza',
  'fabric.emoji.category.objects': 'Objetos',
  'fabric.emoji.category.people': 'Personas',
  'fabric.emoji.category.places': 'Viajes y lugares',
  'fabric.emoji.category.productivity': 'Atlassian y productividad',
  'fabric.emoji.category.symbols': 'Símbolos',
  'fabric.emoji.category.user.uploads': 'Tus elementos subidos',
  'fabric.emoji.choose.file.screenReaderDescription':
    'Elige un archivo para el emoji. JPG, PNG o GIF. Tamaño máximo de 1 MB.',
  'fabric.emoji.choose.file.title': 'Elegir archivo',
  'fabric.emoji.delete.description':
    'Todos los registros que existan de este emoji se sustituirán por {emojiShortName}',
  'fabric.emoji.delete.label': 'Eliminar',
  'fabric.emoji.delete.screenreader.tooltip': 'Para eliminar un emoji de {shortName}, pulsa la tecla de retroceso',
  'fabric.emoji.delete.title': 'Eliminar emoji',
  'fabric.emoji.delete.tooltip': 'Eliminar',
  'fabric.emoji.emojipicker.emoi.roledescription': 'botón de emoji',
  'fabric.emoji.emojipicker.error': '¡Error!',
  'fabric.emoji.error.delete.failed': 'Error de eliminación',
  'fabric.emoji.error.image.too.big': 'La imagen seleccionada ocupa más de 1 MB',
  'fabric.emoji.error.invalid.image': 'La imagen seleccionada no es válida',
  'fabric.emoji.error.upload.failed': 'Error de subida',
  'fabric.emoji.error.upload.timeout': 'Se ha agotado el tiempo de carga',
  'fabric.emoji.image.requirements': 'JPG, PNG o GIF de 1 MB como máximo.',
  'fabric.emoji.name.ariaLabel': 'Introducir un nombre para el nuevo emoji',
  'fabric.emoji.picker': 'Selector de emojis',
  'fabric.emoji.pickerlist.grid': '{showSearchResults, select, true {Resultados de búsqueda} other {Emoticonos}}',
  'fabric.emoji.pickerlist.tabpanel': 'Panel de acciones y listas de emojis',
  'fabric.emoji.placeholder': 'Por ejemplo: hola',
  'fabric.emoji.preview': 'El emoji nuevo {emoji} es genial',
  'fabric.emoji.preview.title': 'Vista previa',
  'fabric.emoji.retry.label': 'Volver a intentarlo',
  'fabric.emoji.search.label': 'Nombre del emoji',
  'fabric.emoji.search.placeholder': 'Buscar',
  'fabric.emoji.search.status': 'Viendo todos los emojis',
  'fabric.emoji.search.status.count': '{count} emoticonos encontrados',
  'fabric.emoji.select.skin.list.ariaLabel': 'Selector de tonos de piel',
  'fabric.emoji.select.skin.tone.ariaLabel': 'Elige tu tono de piel (tono seleccionado: {selectedTone})',
};
